import RequestOptions from 'owa-service/lib/RequestOptions';
import { setExplicitLogonHeaders } from 'owa-headers';

export default function PublicFolderRequestInit(publicFolderMailbox: string): RequestOptions {
    const headers = new Headers();
    setExplicitLogonHeaders(publicFolderMailbox, headers);

    return { headers };
}
